import {Button, ButtonBase, Grid, Typography} from "@mui/material";
import Tarjeta_Proyectos from "../Tarjetas/Tarjeta_Proyectos";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {collection, getDocs, deleteDoc, doc} from "firebase/firestore";
import {db} from "../../../firebase/firebase";
import { Snackbar, Alert } from '@mui/material';


const Lista_Proyectos_Dashboard = () => {

    const {sCell} = useResponsive();
    const [proyectos, setProyectos] = useState([]);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [mensajeExito, setMensajeExito] = useState('');

    const handleEliminar = async (id, titulo) => {
        const confirmar = window.confirm(`¿Estás seguro de que deseas eliminar el proyecto "${titulo}"?`);
        if (!confirmar) return;

        try {
            await deleteDoc(doc(db, "proyectos", id));
            setProyectos(prev => prev.filter(proyecto => proyecto.id !== id));

            // Mostrar Snackbar
            setMensajeExito(`Proyecto "${titulo}" eliminado con éxito.`);
            setOpenSnackbar(true);
        } catch (error) {
            console.error("Error al eliminar el proyecto:", error);
        }
    };


    useEffect(() => {
        const fetchProyectos = async () => {
            const querySnapshot = await getDocs(collection(db, 'proyectos'));
            const docs = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setProyectos(docs);
        };

        fetchProyectos();
    }, []);

    if (proyectos.length === 0) return <Typography sx={{pl:13.5}}>Cargando proyectos...</Typography>;


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 10}} sx={{pt: 20,}}>

            <Grid container size={{xs: 12, sm: 12, md:12}}
                  sx={{maxWidth: 1400, px: 3}}>

                <Grid container


                      size={{xs: 12, sm: 12, md: 12}} sx={{}}>
                    <Grid container size={{xs: 12, sm: 6, md: 6}}>
                        <Typography>
                            Nombre
                        </Typography>
                    </Grid>


                    <Grid container justifyContent={'flex-end'} alignItems={'center'}
                          alignItems={'center'} size={{xs: 12, sm: 6, md: 6}}>
                        <Button href={'/dashboard/proyectos/crear'}>
                            Crear
                        </Button>
                    </Grid>

                </Grid>
                <Grid container
                      justifyContent={'flex-start'}
                      alignItems={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}} sx={{}}>

                    {proyectos.map((item, index) => (
                        <Grid container
                              justifyContent={'flex-start'}
                              alignItems={'flex-start'}
                              key={item.id}
                              size={{xs: 12, sm: 12, md: 12}}>
                            <Grid container spacing={2} size={{xs: 12, sm: 12, md: 12}}
                                  sx={{borderBottom: '1px solid #ccc', py: 1}}>
                                <Grid container size={{xs: 12, sm: 12, md: 7}}>
                                    <Typography>
                                        {item.title}
                                    </Typography>
                                </Grid>
                                <Grid container
                                      justifyContent={'flex-end'}
                                      alignItems={'flex-start'}
                                      size={{xs: 12, sm: 5, md: 5}}>
                                    <Button href={`/dashboard/proyectos/${item.id}`}>
                                        Editar
                                    </Button>
                                    <Button  onClick={() => handleEliminar(item.id, item.title)}>
                                        Eliminar
                                    </Button>
                                </Grid>

                            </Grid>
                        </Grid>
                    ))}

                </Grid>

            </Grid>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                    {mensajeExito}
                </Alert>
            </Snackbar>

        </Grid>

    )

}
export default Lista_Proyectos_Dashboard;

// <Tarjeta_Proyectos
//     imagen={item.images[0]}
//     titulo={item.title}
//     id={item.id}
// />